import { HistoryPagev2 } from './HistoryPagev2';

export const HistoryWrapper = () => {
  return <HistoryPagev2 />;
};
